// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

import { FormFieldModel } from "../types/CommonTypes";

export class DateFieldValidation {

    /*
      Handle setting date validations.
      - If the DateMin and DateMax are set, treat these are hard dates.
      - If the Min and Max are set, treat these as day offsets
      - It is possible to use both, but offsets will override hard dates.
      Note: Apparently RequiredFieldModel and EquipmentModel are not the same, but they have the same properties. So we can use FormFieldModel for both.
    */
    static SetDateFieldValidation(field: FormFieldModel, inputName: string) {

        var inpt = $("input[id=" + inputName + "]");

        if (inpt.length) {

            inpt.datepicker('destroy');
            inpt.rules("remove", "dateRangeCheck dateMinCheck dateMaxCheck");
            var startDate = new Date();
            var endDate = new Date();

            //If no ranges are set for a date. Set to 6 months before and after current date.
            if (!field.HasMinValue && !field.HasMaxValue && !field.HasDateMinValue && !field.HasDateMaxValue) {
                inpt.datepicker({
                    minDate: "-180D",
                    maxDate: "+180D"
                });
                startDate.setDate(startDate.getDate() - 180);
                endDate.setDate(endDate.getDate() + 180);
                inpt.rules("add",
                    {
                        dateRangeCheck: [startDate.toLocaleDateString(), endDate.toLocaleDateString()]
                    });
                return;
            }

            //Figure out the start and end dates based on offsets and fixed dates.
            var hasStartDate: boolean = false;
            var hasEndDate: boolean = false;

            if (field.HasMinValue || field.HasDateMinValue) {
                hasStartDate = true;
            }
            if (field.HasMaxValue || field.HasDateMaxValue) {
                hasEndDate = true;
            }

            //Calculate the start date
            if (field.HasMinValue && !field.HasDateMinValue) {
                startDate.setDate(startDate.getDate() + field.MinValue);
            } else if (!field.HasMinValue && field.HasDateMinValue) {
                startDate = new Date(field.DateMinValue.toString());
            } else if (field.HasMinValue && field.HasDateMinValue) {
                var offsetStartDate = new Date();
                var fixedStartDate = new Date();
                offsetStartDate.setDate(startDate.getDate() + field.MinValue);
                fixedStartDate = new Date(field.DateMinValue.toString());

                // Set startDate to the later of offsetStartDate or fixedStartDate
                startDate = offsetStartDate > fixedStartDate ? offsetStartDate : fixedStartDate;
            }

            //Calculate the end date
            if (field.HasMaxValue && !field.HasDateMaxValue) {
                endDate.setDate(endDate.getDate() + field.MaxValue);
            } else if (!field.HasMaxValue && field.HasDateMaxValue) {
                endDate = new Date(field.DateMaxValue.toString());
            } else if (field.HasMaxValue && field.HasDateMaxValue) {
                var offsetEndDate = new Date();
                var fixedEndDate = new Date();
                offsetEndDate.setDate(endDate.getDate() + field.MaxValue);
                fixedEndDate = new Date(field.DateMaxValue.toString());

                // Set endDate to the earlier of offsetEndDate or fixedEndDate
                endDate = offsetEndDate < fixedEndDate ? offsetEndDate : fixedEndDate;
            }

            if (hasStartDate && !hasEndDate) {
                this.SetMinDate(inpt, startDate);
                return;
            }
            if (!hasStartDate && hasEndDate) {
                this.SetMaxDate(inpt, endDate);
                return;
            }
            if (hasStartDate && hasEndDate) {
                this.SetDateRange(inpt, startDate, endDate);
                return;
            }

        }
    }

    private static SetMinDate(inpt: JQuery<HTMLElement>, minimumDate: Date) {
        inpt.datepicker({
            onSelect: this.ShowDates,
            minDate: minimumDate
        });
        inpt.rules("add",
            {
                dateMinCheck: [minimumDate.toLocaleDateString()]
            });
        return;
    }

    private static SetMaxDate(inpt: JQuery<HTMLElement>, maximumDate: Date) {
        inpt.datepicker({
            onSelect: this.ShowDates,
            maxDate: maximumDate
        });
        inpt.rules("add",
            {
                dateMaxCheck: [maximumDate.toLocaleDateString()]
            });
    }

    private static SetDateRange(inpt: JQuery<HTMLElement>, minimumDate: Date, maximumDate: Date) {
        inpt.datepicker({
            onSelect: this.ShowDates,
            minDate: minimumDate,
            maxDate: maximumDate
        });
        inpt.rules("add",
            {
                dateRangeCheck: [minimumDate.toLocaleDateString(), maximumDate.toLocaleDateString()]
            });
        return;
    }
}